import React from "react";
import "../styles/About.css";
import SkillWord from "./SkillWord";

export default function About() {

  return (
    <div id="about" className="AboutContainer">
      <section className="AboutSectionTop">
        <p className="MainTitle">About me</p>
        <p className="AboutTitlesUnderline">___________________</p>
        <p className="MainTitleDesc">
        I'm a final year student at IIT Bhubaneswar. I'm a dedicated tech enthusiast with a passion for problem-solving and a knack for building innovative solutions. I'm always eager to explore new technologies and embrace challenges that come my way. My interests include applying machine learning and deep learning techniques for solving real world projects.
        I apply machine learning techniques for solving real cases that my  domain presents to me.
        I am looking to leverage my strong programming skills in Python, analytical aptitude and knowledge of data visualizations to effectively analyze, interpret, and present insights from large datasets in an accurate and meaningful way. 
        Seeking to collaborate with a leading data science and AI team to develop innovative models to detect patterns and trends for complex data-driven solutions.

        </p>
      </section>
      <div className="AboutBottomContainer">
        <div className="AboutBottomLeft">
          <section className="AboutSectionBottom">
            <p className="MainTitle2">Skills</p>
            <p className="AboutTitlesUnderline">__________</p>
            <p className="SubTitle">Languages</p>
            <p className="SubTitleDesc">
              C++, Python
            </p>
            <p className="SubTitle">Machine Learning</p>
            <p className="SubTitleDesc">
               Supervised Learning, Unsupervised, Data Visualization, Data Analysis, ANN,CNN
            </p>
            <p className="SubTitle">Web Technologies</p>
            <p className="SubTitleDesc">
               HTML, CSS, Flask
            </p>
            <p className="SubTitle">Database Management system</p>
            <p className="SubTitleDesc">
              MySQL
            </p>
            <p className="SubTitle">Tools</p>
            <p className="SubTitleDesc"> Power BI, MS Excel</p>
          </section>
        </div>
        <div className="AboutBottomRight">
          <h1 className="SkillWord">
            <SkillWord/>
          </h1>
        </div>
      </div>
      <div className="ContactButtonContainer">
        <a href="#contact" className="ContactMe">
          Let's talk!
        </a>
      </div>
    </div>
  );
}
